import { http } from '@/core/api/';

export default {
  async getPositions() {
    return await http.get('api/signature/availablepositionsTab9');
  },
  async removeFromDefaults(groupId, peiId) {
    return await http.post(
      `api/signature/${groupId}/${peiId}/removeFromDefaults`
    );
  },
  async getParticipationTypeList() {
    return await http.get('/api/pei/participationTypeList');
  },
  async getAlternateParticipationTypeList() {
    return await http.get('/api/pei/alternateParticipationTypeList');
  },
  async getDefaultConfiguration(pei, studentSieId) {
    if (pei === null) {
      return await http.get(
        `api/signature/${studentSieId}/defaultConfiguration`
      );
    } else {
      return await http.get(
        `api/signature/${pei}/${studentSieId}/getDefaultConfiguration`
      );
    }
  },
  async getAvailableSignatureOptions() {
    return await http.get('/api/signature/availablepositionsTab9');
  },
  async getFamilyAgenciesTab(peid) {
    return await http.get(`/api/pei/familyagenciestab?peiId=${peid}`);
  },

  //Signatures Methods
  /*
    this.availableSignatureOptions,
    this.model.participants,
    {
      readonly: this.readonly,
      signatureCounter: this.signatureCounter,
      isDraft: this.readonly,
    },
    config.id,
    config.value
  */
  getBasicSignature(
    availableSignatureOptions,
    signatures,
    options,
    groupId,
    removable = false
  ) {
    let signature = signatures.find((x) =>
      availableSignatureOptions.some(
        (y) =>
          y.signatureGroupId == groupId &&
          y.signaturePositionId == x.positionCode
      )
    );
    let signatureForm = undefined;
    if (signature != undefined) {
      signatureForm = {
        id: signature.id,
        signature: {
          name: signature.fullName,
          positionId: { signaturePositionId: signature.positionCode },
          participationId: { id: signature.participationTypeId },
          alternateId: { id: signature.alternateParticipationTypeId },
        },
        groupId: groupId,
        isRequired: false, //Default is false change in same view for get refer validationTrigger
        isRemovable: removable,
        isDraft: options.readonly,
        isDisabled: options.readonly,
        isBasic: true,
      };
    } else {
      if (!options.readonly) {
        signatureForm = {
          id: options.signatureCounter,
          signature: {
            name: '',
            positionId: undefined,
            participationId: undefined,
            alternateId: undefined,
          },
          groupId: groupId,
          isRequired: false, //Default is false change in same view for get refer validationTrigger
          isRemovable: removable,
          isBasic: true,
        };
      }
    }
    return signatureForm;
  },
};
